import auth from '../middleware/auth';
const MensagemList = () =>
  import('../components/Views/Colegio/Mensagem/List.vue');
const MensgemNew = () => import('../components/Views/Colegio/Mensagem/New.vue');
const ResumoDiario = () =>
  import('../components/Views/Colegio/ResumoDiario/Inicio.vue');
const Evento = () => import('../components/Views/Colegio/Evento/Inicio.vue');
const Inicio = () => import('../components/Views/Colegio/Inicio.vue');
const Home = () => import('../components/Views/Home.vue');

const breadcrumb = [
  { name: 'IntegradON', link: process.env.INTERNO_URL },
  { name: 'Agenda', link: '/agenda' }
];

const agenda = [
  {
    path: '/agenda',
    component: Home,
    meta: {
      middleware: auth
    },
    children: [
      {
        path: '/agenda',
        component: Inicio,
        name: 'Agenda',
        meta: {
          middleware: auth,
          breadcrumb: [
            { name: 'IntegradON', link: process.env.INTERNO_URL }
          ]
        }
      },
      {
        path: '/agenda/mensagem',
        component: MensagemList,
        name: 'Mensagens',
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: '/agenda/mensagem/new',
        component: MensgemNew,
        name: 'Nova Mensagem',
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: '/agenda/eventos',
        component: Evento,
        name: 'Eventos',
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: '/agenda/resumo-diario',
        component: ResumoDiario,
        name: 'Resumos Diários',
        meta: {
          middleware: auth,
          breadcrumb
        }
      }
    ]
  }
];

export default agenda;



// WEBPACK FOOTER //
// ./src/routes/agenda.js